import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { SemiDonughnutGraph } from "../molecules"
import { OverviewUtilizationCard, ChallengesUtilizationCard } from "../atoms"
import { FullStar } from "../../../assets/images"
import { BENEFIT_TYPE_MAP, SERVICE_CARD_DETAILS } from "../../../constants/overview"
import { handleAppError } from "../../handlers"
import { commaingNumber, computeRating } from "../../../utils"
import { SpinnerDotted } from "../../common/atoms"

const OverviewServiceCard = ({ benefitType = '', contractId, startDate, endDate, totalCustomerCount = 0, classes = '', isRunningContract = false, setUilizationToBenefit }) => {
  const [state, setState] = useState({ loading: true })
  const history = useHistory()
  const service = BENEFIT_TYPE_MAP[benefitType] ?? benefitType
  const details = SERVICE_CARD_DETAILS[service]
  const digitization = sessionStorage.getItem('digitization');
  const digitization_disable = digitization == 'digitization_disable';
  useEffect(() => {
    if(!contractId) return
  
    setState(prevState => { return {...prevState, loading: true} })
    details['requestApi']({ contract_id: contractId, start_date: startDate, end_date: endDate },
      (res) => {
        setState({...res.data, loading: false})
      },
      (err) => handleAppError(err)
    )
  }, [contractId])

  const getColor = (number) => {
    number = parseInt(number, 10)
    switch(true) {
      case number <= 515: return '#C54B4F'
      case number >= 516 && number <= 670: return '#FF9800'
      case number >= 671: return '#00A04F'
    }
  }

  const getServiceData = (service) => {
    const { sponsored_appointments = 0, sponsored_spendings = 0,
      sponsored_utilized_employees_count = 0, sponsored_ratings = {}, utilized_employees_count = 0, consultations_count = 0, 
      consultations_amount = 0, consultations_ratings = {}, hra_completed_count = 0, current_health_score = 0, optimum_health_score = 0, ready_to_book = 0,
      awaiting_approval = 0, ongoing_requests = 0, completed_requests = 0 } = state

    var title = service?.replace(/_/g, ' ') ?? ''
    var totalEmployeeCount = state?.total_employee_count ?? totalCustomerCount

    switch(service) {
      case 'consultations':
        title = 'Doctor consultation'
        var completed = utilized_employees_count ?? 0
        var availedAppointments = commaingNumber(consultations_count)
        var availedSpendings = '₹' + commaingNumber(parseInt(consultations_amount, 10))
        var ratingsData = computeRating(consultations_ratings) ?? 0
        var utilization = 0
        if(completed > 0) {
          utilization = totalEmployeeCount > 0 ? Math.round((completed * 100) / totalEmployeeCount) : 0
          setUilizationToBenefit(utilization)
        }
        return { completed, availedAppointments, availedSpendings, ratingsData, title, utilization }
      case 'hra':
        title = 'Health Risk Assessment (HRA)'
        var completed = hra_completed_count ?? 0
        var availedAppointments = commaingNumber(current_health_score)
        availedAppointments = <span className="font-semibold" style={{ color: getColor(availedAppointments) }}>{availedAppointments}</span>
        var availedSpendings = commaingNumber(optimum_health_score)
        availedSpendings = <span className="font-semibold" style={{ color: getColor(availedSpendings) }}>{availedSpendings}</span>
        var utilization = 0
        if(completed > 0) {
          utilization = totalEmployeeCount > 0 ? Math.round((completed * 100) / totalEmployeeCount) : 0
          setUilizationToBenefit(utilization)
        }
        return { completed, availedAppointments, availedSpendings, ratingsData, title, utilization }
      case 'pre_employment':
        title = 'Pre employment'
        var completed = completed_requests ?? 0
        var availedAppointments = ready_to_book
        var availedSpendings = awaiting_approval
        return { ongoing_requests, completed, availedAppointments, availedSpendings, title }
      default:
        title = title.charAt(0).toUpperCase() + title.slice(1)
        var completed = sponsored_utilized_employees_count ?? 0
        var availedAppointments = commaingNumber(sponsored_appointments)
        var availedSpendings = '₹' + commaingNumber(parseInt(sponsored_spendings, 10))
        var ratingsData = computeRating(sponsored_ratings) ?? 0
        var utilization = 0
        if(completed > 0) {
          utilization = totalEmployeeCount > 0 ? Math.round((completed * 100) / totalEmployeeCount) : 0
          setUilizationToBenefit(utilization)
        }
        return { completed, availedAppointments, availedSpendings, ratingsData, title, utilization }
    }
  }

  const dataCardsTitles = details['cardTiles'] ?? []
  const dataCardsLiners = details['cardLiners'](isRunningContract)
  const serviceData = getServiceData(service)
  const { sponsored = false, loading } = state
  const { completed, availedAppointments, availedSpendings, ratingsData = [0, 0], title = '', ongoing_requests, utilization } = serviceData
  const [avgRating, totalRatings] = ratingsData

  if(![null, undefined].includes(utilization) && completed < 1) {
    return (
      <div className={`bg-white border border-gray-200 rounded-lg p-6 ${classes}`}>
        <div className='flex justify-between items-center'>
          <div className='flex gap-3'>
            <img src={details['icon']} className='h-8 w-8' />
            <div  className='flex flex-col justify-center'>
              <h1 className='text-base text-gray-700 mb-0 leading-none flex gap-4'>
                <span className='font-semibold'>{title}</span>
                { sponsored && <span className='text-white inline-block text-xs rounded-full px-2 py-1 -mt-1 font-semibold bg-green-1000'>Sponsored</span>}
              </h1>
              <h3 className='mb-0 mt-1'>This feature has not been utilized</h3>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-6 ${classes}`}>
      <div className='flex justify-between items-center'>
        <div className='flex gap-3'>
          <img src={details['icon']} className='h-8 w-8' />
          <div  className='flex flex-col justify-center'>
            <h1 className='text-base text-gray-700 mb-0 leading-none flex gap-4'>
              <span className='font-semibold'>{title}</span>
              { sponsored && <span className='text-white inline-block text-xs rounded-full px-2 py-1 -mt-1 font-semibold bg-green-1000'>Sponsored</span>}
            </h1>
            {!['hra', 'pre_employment'].includes(service) && !!totalRatings && 
              <h3 className='flex items-center text-gray-600 mb-0'>
                <img src={FullStar} className='inline-block h-4 w-4 mr-1'/>
                <span style={{ fontSize: 12 }}><strong style={{ fontSize: 14 }}>{avgRating}</strong>/5 ({commaingNumber(totalRatings)} verified ratings)</span>
              </h3>
            }
          </div>
        </div>
        <div className='text-base text-blue-600 flex gap-4'>
            { details['btns'] &&
              details['btns'].map((item) => {
                return (
                  <>
                    {/* hide the btton when digitization_disable and link is test-results*/}
                    {digitization_disable && item?.link === '/test-results' ? null : (
                      <button
                        key={item.text}
                        className='border border-gray-275 rounded-md bg-white px-4 py-2 font-semibold'
                        onClick={() => history.push(item.link)}
                      >
                        {item.text}
                      </button>
                    )}
                  </>
                );
              })
            }
        </div>
      </div>
      {!loading ? 
        <div className='grid grid-cols-3 gap-6 mt-6'>
          <div className='flex flex-col'>
            <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{dataCardsTitles[0]}</h3>
            { service === 'pre_employment' ?
              <ChallengesUtilizationCard title1={ongoing_requests} title2={completed} liner1='Ongoing checks' liner2='Completed checks' classes='flex-1 gap-6 mt-2' />
              :
              <SemiDonughnutGraph linerStyles={completed.toString().length > 5 ? 'w-7/12 text-center bottom-6' : 'bottom-11'} id={service + 'myChart'} total={state?.total_employee_count ?? totalCustomerCount} completed={completed} title='employees utilization graph' liner={<span><span className='font-semibold text-sm'>{completed}*</span> out of {state?.total_employee_count ?? totalCustomerCount} employees</span>} graphClasses='-mt-8 -mb-4' classes='mt-2 flex-1' metricValue={details['donutCardLiner']} />
            }
          </div>
          <div className='flex flex-col'>
            <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{dataCardsTitles[1]}</h3>
            <OverviewUtilizationCard title={availedAppointments} liner={dataCardsLiners[0]} classes='flex-1 mt-2' btnText = {details['viewDetailsLink'] ? 'View detailed breakup' : ''} btnHandler = {details['viewDetailsLink'] ? () => history.push(details['viewDetailsLink'], { contractId }) : ''} />
          </div>
          <div className='flex flex-col'>
            <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{dataCardsTitles[2]}</h3>
            <OverviewUtilizationCard title={availedSpendings} liner={dataCardsLiners[1]} classes='flex-1 mt-2' />
          </div>
        </div> :
        <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }
    </div>
  )
}

export default OverviewServiceCard